import React from 'react';
import { Router, Route } from 'react-router';

import App from './components/App/App';
import NotFound from './components/NotFound/NotFound';

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={App} />
    <Route path="*" component={NotFound} />
  </Router>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js